import { render, staticRenderFns } from "./RcvD_Details.vue?vue&type=template&id=9929b50a"
import script from "./RcvD_Details.vue?vue&type=script&lang=js"
export * from "./RcvD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports